/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CallResultTypesImport400Response } from '../models';
// @ts-ignore
import { GetCallResultTypeSummaries200Response } from '../models';
/**
 * CallResultTypeApi - axios parameter creator
 * @export
 */
export const CallResultTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * クライアントのコール結果タイプを Excel 形式でエクスポートするAPI
         * @summary コール結果のエクスポート
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callResultTypesExport: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/call_result_types_export_excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * コール結果のインポートAPI
         * @summary コール結果のインポート
         * @param {any} file コール結果インポート用のxlsxファイル
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callResultTypesImport: async (file: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('callResultTypesImport', 'file', file)
            const localVarPath = `/api/user/call_result_types_import_excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * コール結果インポート用のExcelテンプレートをダウンロードするAPI
         * @summary コール結果インポートテンプレートのダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callResultTypesImportTemplate: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/downloads/call_result_types_import_template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * コール結果タイプ概要一覧取得API
         * @summary コール結果タイプ概要一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallResultTypeSummaries: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/call_result_types/summaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallResultTypeApi - functional programming interface
 * @export
 */
export const CallResultTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CallResultTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * クライアントのコール結果タイプを Excel 形式でエクスポートするAPI
         * @summary コール結果のエクスポート
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callResultTypesExport(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callResultTypesExport(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * コール結果のインポートAPI
         * @summary コール結果のインポート
         * @param {any} file コール結果インポート用のxlsxファイル
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callResultTypesImport(file: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callResultTypesImport(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * コール結果インポート用のExcelテンプレートをダウンロードするAPI
         * @summary コール結果インポートテンプレートのダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callResultTypesImportTemplate(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callResultTypesImportTemplate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * コール結果タイプ概要一覧取得API
         * @summary コール結果タイプ概要一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallResultTypeSummaries(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCallResultTypeSummaries200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallResultTypeSummaries(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CallResultTypeApi - factory interface
 * @export
 */
export const CallResultTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CallResultTypeApiFp(configuration)
    return {
        /**
         * クライアントのコール結果タイプを Excel 形式でエクスポートするAPI
         * @summary コール結果のエクスポート
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callResultTypesExport(options?: any): AxiosPromise<any> {
            return localVarFp.callResultTypesExport(options).then((request) => request(axios, basePath));
        },
        /**
         * コール結果のインポートAPI
         * @summary コール結果のインポート
         * @param {any} file コール結果インポート用のxlsxファイル
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callResultTypesImport(file: any, options?: any): AxiosPromise<void> {
            return localVarFp.callResultTypesImport(file, options).then((request) => request(axios, basePath));
        },
        /**
         * コール結果インポート用のExcelテンプレートをダウンロードするAPI
         * @summary コール結果インポートテンプレートのダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callResultTypesImportTemplate(options?: any): AxiosPromise<any> {
            return localVarFp.callResultTypesImportTemplate(options).then((request) => request(axios, basePath));
        },
        /**
         * コール結果タイプ概要一覧取得API
         * @summary コール結果タイプ概要一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallResultTypeSummaries(options?: any): AxiosPromise<GetCallResultTypeSummaries200Response> {
            return localVarFp.getCallResultTypeSummaries(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CallResultTypeApi - interface
 * @export
 * @interface CallResultTypeApi
 */
export interface CallResultTypeApiInterface {
    /**
     * クライアントのコール結果タイプを Excel 形式でエクスポートするAPI
     * @summary コール結果のエクスポート
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallResultTypeApiInterface
     */
    callResultTypesExport(options?: AxiosRequestConfig): AxiosPromise<any>;

    /**
     * コール結果のインポートAPI
     * @summary コール結果のインポート
     * @param {any} file コール結果インポート用のxlsxファイル
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallResultTypeApiInterface
     */
    callResultTypesImport(file: any, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * コール結果インポート用のExcelテンプレートをダウンロードするAPI
     * @summary コール結果インポートテンプレートのダウンロード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallResultTypeApiInterface
     */
    callResultTypesImportTemplate(options?: AxiosRequestConfig): AxiosPromise<any>;

    /**
     * コール結果タイプ概要一覧取得API
     * @summary コール結果タイプ概要一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallResultTypeApiInterface
     */
    getCallResultTypeSummaries(options?: AxiosRequestConfig): AxiosPromise<GetCallResultTypeSummaries200Response>;

}

/**
 * Request parameters for callResultTypesImport operation in CallResultTypeApi.
 * @export
 * @interface CallResultTypeApiCallResultTypesImportRequest
 */
export interface CallResultTypeApiCallResultTypesImportRequest {
    /**
     * コール結果インポート用のxlsxファイル
     * @type {any}
     * @memberof CallResultTypeApiCallResultTypesImport
     */
    readonly file: any
}

/**
 * CallResultTypeApi - object-oriented interface
 * @export
 * @class CallResultTypeApi
 * @extends {BaseAPI}
 */
export class CallResultTypeApi extends BaseAPI implements CallResultTypeApiInterface {
    /**
     * クライアントのコール結果タイプを Excel 形式でエクスポートするAPI
     * @summary コール結果のエクスポート
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallResultTypeApi
     */
    public callResultTypesExport(options?: AxiosRequestConfig) {
        return CallResultTypeApiFp(this.configuration).callResultTypesExport(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * コール結果のインポートAPI
     * @summary コール結果のインポート
     * @param {CallResultTypeApiCallResultTypesImportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallResultTypeApi
     */
    public callResultTypesImport(requestParameters: CallResultTypeApiCallResultTypesImportRequest, options?: AxiosRequestConfig) {
        return CallResultTypeApiFp(this.configuration).callResultTypesImport(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * コール結果インポート用のExcelテンプレートをダウンロードするAPI
     * @summary コール結果インポートテンプレートのダウンロード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallResultTypeApi
     */
    public callResultTypesImportTemplate(options?: AxiosRequestConfig) {
        return CallResultTypeApiFp(this.configuration).callResultTypesImportTemplate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * コール結果タイプ概要一覧取得API
     * @summary コール結果タイプ概要一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallResultTypeApi
     */
    public getCallResultTypeSummaries(options?: AxiosRequestConfig) {
        return CallResultTypeApiFp(this.configuration).getCallResultTypeSummaries(options).then((request) => request(this.axios, this.basePath));
    }
}
